import { axiosAuth } from "services/generic/AxiosInterceptor/AxiosInterceptor"
import { generateFormData } from "services/generic/HttpUtils"

import { DigidConfigResponse } from "@shared/zod/schemas/responses/digid"

export const getConfig = async (practiceId: string): Promise<DigidConfigResponse> => {
  return axiosAuth({
    url: `/digid/settings/${practiceId}/config`,
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const updateConfig = async (
  practiceId: string,
  publicCert: File | null,
  privateKey: File | null,
  entityId: string | null,
  serviceId: string | null
): Promise<DigidConfigResponse> => {
  return await axiosAuth({
    url: `/digid/settings/${practiceId}/config`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: generateFormData({ entityId, serviceId }, [publicCert, privateKey], ["publicCert", "privateKey"]),
  }).then((resp) => {
    return resp.data
  })
}

export const disableDigid = async (practiceId: string): Promise<void> => {
  await axiosAuth({
    url: `/digid/settings/${practiceId}`,
    method: "delete",
  }).then(() => undefined)
}
